module.exports = __webpack_public_path__ + "img/MitID_logo.80654f0a.svg";